/**
* 班级任务与个人完成情况
*/
<template>
    <span>
        <a @click="openmodel()">详情</a>
        <a-modal :visible="visible" :width="1280" title="任务详细情况" @ok="okmodel" @cancel="cancelmodel">
            <a-row :gutter="16" style="margin-left: 50px">
                <a-col :span="6">
                    <a-statistic title="班级人数" :value="itemdata.actual">
                        <template #suffix>
                            <a-icon type="like" />
                        </template>
                    </a-statistic>
                </a-col>
            <a-col :span="6">
                <a-statistic title="应参" :value="itemdata.statistic" class="demo-class">
                        <!-- <template #suffix>
                        <span> / 100</span>
                      </template> -->
                    </a-statistic>
                </a-col>

            <a-col :span="6">
                <a-statistic title="不参(住校)" :value="itemdata.actual - itemdata.statistic" class="demo-class">
                        <!--  <template #suffix>
                        <span> / 100</span>
                      </template> -->
                    </a-statistic>
                </a-col>
            </a-row>

            <a-divider></a-divider>
            <div>
                <a-table :dataSource="tabledata" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                    @change="onPaginationChange" bordered>
                    <a-table-column key="missionname" title="任务名" data-index="missionname" />

                    <a-table-column key="squad_student_arrive" width="50px" title="总应参" data-index="squad_all_usermission"
                        :sorter="(item1, item2) => item1.squad_all_usermission - item2.squad_all_usermission" />
                    <a-table-column key="squad_all_student_actual" width="50px" title="总实参"
                        data-index="squad_all_student_actual"
                        :sorter="(item1, item2) => item1.squad_all_student_actual - item2.squad_all_student_actual" />

                    <a-table-column key="squad_student_arrive" width="50px" title="应参除住校" data-index="squad_student_arrive"
                        :sorter="(item1, item2) => item1.squad_student_arrive - item2.squad_student_arrive" />
                    <!-- <a-table-column key="squad_student_arrive" title="正常参测人次" data-index="squad_student_arrive" :sorter="(item1, item2) => item1.squad_student_arrive - item2.squad_student_arrive"/> -->
                    <a-table-column key="squad_student_actual" width="50px" title="实参除住校" data-index="squad_student_actual"
                        :sorter="(item1, item2) => item1.squad_student_actual - item2.squad_student_actual" />
                    <a-table-column key="problems_cnt" width="50px" title="总题目" data-index="problems_cnt"
                        :sorter="(item1, item2) => item1.problems_cnt - item2.problems_cnt" />
                    <a-table-column key="problems_tj_cnt" width="50px" title="已做数" data-index="problems_tj_cnt"
                        :sorter="(item1, item2) => item1.problems_tj_cnt - item2.problems_tj_cnt" />
                    <a-table-column key="problems_correct" width="50px" title="已改" data-index="problems_correct"
                        :sorter="(item1, item2) => item1.problems_correct - item2.problems_correct" />
                    <a-table-column key="problems_isright" width="50px" title="正确" data-index="problems_isright"
                        :sorter="(item1, item2) => item1.problems_isright - item2.problems_isright" />

                    <a-table-column key="sjccl" title="参测率">
                        <template slot-scope="item">
                            {{ parseFloat(item.squad_all_student_actual / item.squad_all_usermission).toFixed(2) }}

                        </template>
                    </a-table-column>
                    <a-table-column key="zql" title="正确率">
                        <template slot-scope="item">
                            {{ item.problems_answer_cnt > 0 ? parseFloat(item.problems_isright / item.problems_correct * 100).toFixed(2) : 0 }}%
                        </template>
                    </a-table-column>

                    <a-table-column key="sjpgl" title="批改率">
                        <template slot-scope="item">
                            {{ item.problems_answer_cnt > 0 ? parseFloat(item.problems_correct / item.problems_tj_cnt * 100).toFixed(2) : 0 }}%
                        </template>
                    </a-table-column>
                    <a-table-column key="missiontypename" title="任务类型" data-index="missiontypename" />
                    <a-table-column key="active" width="80px" title="操作">
                        <template slot-scope="item">
                            <squadmissioninfomodel v-bind:itemdata="item" v-bind:squad_id="item.squad_id"
                                v-bind:mission_id="item.mission_id"></squadmissioninfomodel>
                        </template>
                    </a-table-column>
                </a-table>
                <div>总共{{ pageinfo.total }}条数据</div>
                <a-switch size="small" v-model="showcount" @change="getshowcount" />
            </div>

        </a-modal>
    </span>
</template>
<script>
import squadmissioninfomodel from '@/views/basic/squadmissioninfomodel.vue';
//   import  squadusermodel from '@/views/orgpublish/squadusermodel.vue';
export default {
    components: {
        squadmissioninfomodel,

    },
    props: {
        itemdata: {},
        searchFrom: {}
    },
    data() {
        return {
            data: [],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 10
            },
            showcount: false,
            tabledata: [],
            loading: false,
            visible: false,
            squadinfo: [],
        };
    },
    mounted() {

    },
    computed: {
        rowSelection() {
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    selectedRows;
                },

            };
        },
    },
    methods: {
        getshowcount() {

            if (this.showcount) {
                this.pageinfo.pageSize = 9999;
                this.pageinfo.current = 1;
                // this.showcount=true;
            }
            if (!this.showcount) {
                this.pageinfo.pageSize = 10;
                this.pageinfo.current = 1;
                // this.showcount=false;
            }
            this.getTableList();
        },

        getTableList() {
            this.searchFrom.squad_id = this.itemdata.id;
            this.loading = true;
            this.$axios
                .post("/api/AnalyseInfo/getsquadMissionlist", {
                    data: this.searchFrom,
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                        this.tabledata = null;
                    } else {
                        this.tabledata = res.data.data;
                        this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        },

        openmodel() {
            this.visible = true;
            this.getTableList();
        },
        okmodel() {
            this.visible = false;
        },
        cancelmodel() {
            this.visible = false;
        },

        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList();
        },


    }
};
</script>
<style>.active_btn {
    margin-left: 5px;
}</style>
